import React from 'react';
import TabellaGenerale from '../TabellaGenerale';

function AreaVarie() {
    return (
        <TabellaGenerale titolo="Area varie" url="areavarie" nome="Varie" numTabella={2} />
    );
};

export default AreaVarie;